import React, { useState } from "react";
import "../assets/css/faqSection.css";
import { IoCall } from "react-icons/io5";

const faqs = [
    {
        question: "What industries use your resins?",
        answer:
            "Our UF, MF, MUF, PF & Binder resins are used in plywood, laminates, molding, adhesives, and fish-feed manufacturing."
    },
    {
        question: "Do you provide resin in both liquid and powder form?",
        answer:
            "Yes, we manufacture and supply resins in both liquid and powder forms depending on application requirements."
    },
    {
        question: "Can I get technical assistance for using your resin?",
        answer:
            "Absolutely. Our technical team provides complete guidance for application, usage, and optimization."
    },
    {
        question: "Do you offer nationwide delivery?",
        answer:
            "Yes, we deliver our products across India through a reliable logistics network."
    }
];

const FaqSection = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <section className="faq-wrapper">
            <div className="faq-container">

                {/* LEFT */}
                <div className="faq-left">
                    <span className="section-tag">FAQS</span>
                    <h2>Frequently Asked Questions</h2>

                    <div className="faq-cta">
                        <p>
                            Looking for reliable industrial resins?
                            <br />
                            Contact us today!
                        </p>

                        <a style={{width:'fit-content'}} className="call-btn call-btn-multi" href="tel:+918160995833">
                            <div className="call-line">
                                <IoCall />
                                <span>+91 8160995833</span>
                            </div>
                            <div className="call-line">
                                <IoCall />
                                <span>+91 9979619001</span>
                            </div>
                            <div className="call-line">
                                <IoCall />
                                <span>+91 9586127173</span>
                            </div>
                        </a>
                    </div>
                </div>

                {/* RIGHT */}
                <div className="faq-right">
                    {faqs.map((item, index) => (
                        <div
                            key={index}
                            className={`faq-item ${activeIndex === index ? "active" : ""}`}
                            onClick={() =>
                                setActiveIndex(activeIndex === index ? -1 : index)
                            }
                        >
                            <div className="faq-question">
                                <h4>{item.question}</h4>
                                <span className="toggle" style={{ height: '36px', width: '36px' }}>
                                    {activeIndex === index ? "−" : "+"}
                                </span>
                            </div>

                            <div className="faq-answer">
                                <p>{item.answer}</p>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default FaqSection;
